import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Container,
  Grid,
  Avatar,
  Divider
} from '@mui/material';
import {
  Person as PersonIcon,
  Security as SecurityIcon,
  Notifications as NotificationsIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';
import SecuritySettings from '../components/profile/SecuritySettings';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
};

const ProfilePage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Grid container spacing={4}>
        {/* Profile header */}
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Avatar
                sx={{ width: 80, height: 80, mr: 3, bgcolor: 'primary.main' }}
              >
                <Typography variant="h4">JD</Typography>
              </Avatar>
              <Box>
                <Typography variant="h4" gutterBottom>
                  John Doe
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  john.doe@example.com
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>

        {/* Tab navigation */}
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ mb: 4 }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="fullWidth"
              aria-label="profile settings tabs"
            >
              <Tab icon={<PersonIcon />} label="Profile" />
              <Tab icon={<SecurityIcon />} label="Security" />
              <Tab icon={<NotificationsIcon />} label="Notifications" />
              <Tab icon={<SettingsIcon />} label="Preferences" />
            </Tabs>
          </Paper>
        </Grid>

        {/* Tab content */}
        <Grid item xs={12}>
          <TabPanel value={tabValue} index={0}>
            <Paper elevation={3} sx={{ p: 4 }}>
              <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                <PersonIcon sx={{ mr: 1 }} /> Personal Information
              </Typography>
              <Divider sx={{ mb: 3 }} />
              
              <Typography variant="body1" paragraph>
                Profile settings will be implemented here. This section will include fields for updating
                name, email, profile picture, and other personal information.
              </Typography>
            </Paper>
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <SecuritySettings />
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <Paper elevation={3} sx={{ p: 4 }}>
              <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                <NotificationsIcon sx={{ mr: 1 }} /> Notification Settings
              </Typography>
              <Divider sx={{ mb: 3 }} />
              
              <Typography variant="body1" paragraph>
                Notification settings will be implemented here. This section will include options for
                email notifications, in-app notifications, and notification preferences.
              </Typography>
            </Paper>
          </TabPanel>

          <TabPanel value={tabValue} index={3}>
            <Paper elevation={3} sx={{ p: 4 }}>
              <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                <SettingsIcon sx={{ mr: 1 }} /> Preferences
              </Typography>
              <Divider sx={{ mb: 3 }} />
              
              <Typography variant="body1" paragraph>
                User preferences will be implemented here. This section will include options for
                theme settings, language preferences, and other customization options.
              </Typography>
            </Paper>
          </TabPanel>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ProfilePage; 